<template>
  <main class="main">

      <div class="header">
        <div class="tabs">
<!--          <router-link to=""  v-for="({name, title, status}, key) in navs"-->
<!--                       :key="key+'nav_org'"-->
<!--                       @click="getOffers(status)"-->
<!--                       class="tabs-item" tag="div" active-class="active">-->
<!--            {{ title }}-->
<!--          </router-link>-->
          <div class="tabs-item"
               v-for="({name, title, status}, key) in navs"
               :key="key+'nav_org'"
               :class="{active: key == select_key}"
               @click="changeFilter(key, status)">
            {{ title }}</div>
        </div>
        <div class="search ">
          <input autocomplete="off" name="search" placeholder="Поиск" v-model="search" @keyup="searchOffers()">
          <img src="@/assets/img/worker/search.svg" alt="">
        </div>
        <button v-if="!purchaser">
          <router-link to="offer/create"  style="color: #FFFFFF;">
            Создать КП
          </router-link>
        </button>
      </div>
      <div class="table">
        <loading-container :loading="loading" >
        <table >
          <tr>
            <th>ID</th>
            <th>Дата</th>
            <th>{{ !purchaser ? 'Клиент' : 'Поставщик' }}</th>
            <th>Рейтинг</th>
            <th>Статус</th>
            <th width="170px">Действует до</th>
            <th width="60px">Вход</th>
            <th width="60px">Меню</th>
          </tr>
          <tr v-for="(item, idx) in offers" :key="idx">
            <td>{{item.id}}</td>
            <td>{{$moment(item.created_at).format('DD - MMMM - YYYY')}}</td>
            <td>{{purchaser ? item.provider ? item.provider.name : '' : item.purchaser ? item.purchaser.name : ''}}</td>
            <td style="color: #F39220">{{item.avg}}</td>
            <td v-if="purchaser" :style="item.provider_contract && item.provider_contract.accept == 0 ? 'color: rgba(44, 177, 129, 1)' : item.status == 2 ? 'color: rgba(235, 87, 87, 1)' :  item.status == 3 ? 'color: rgba(243, 146, 32, 1)' : ''">
              <!--{{item.provider_contract && item.provider_contract.accept == 0 ? 'Заключается договор' :
                item.status == 1 ? 'В ожидании' :
                item.status == 2 ? 'Отклонено'
                    :  item.status == 3 ? 'Потенциально интересно'
                    : ""
            }}-->
                {{item.human_status}}
            </td>
            <td v-if="!purchaser"
                :style="item.purchaser && item.purchaser.purchaser_contract && item.purchaser.purchaser_contract.accept == 0 ? 'color: rgba(44, 177, 129, 1)' :
                 item.status == 2 ? 'color: rgba(235, 87, 87, 1)' :
                   item.status == 3 ? 'color: rgba(243, 146, 32, 1)' : ''"
            >
              <!--{{item.purchaser && item.purchaser.purchaser_contract && item.purchaser.purchaser_contract.accept == 0 ? 'Заключается договор' :
                item.status == 1 ? 'В ожидании' :
                item.status == 2 ? 'Отклонено'
                    :  item.status == 3 ? 'Потенциально интересно'
                    : item.status == 0 ? 'Черновик' :""
            }}-->
                {{item.human_status}}
            </td>
            <td>{{item.active_to_date ? $moment(item.active_to_date).format('DD - MMMM - YYYY') : ''}}</td>
            <td>
              <router-link :to="item.status == 0 ? 'offer/'+item.id+'/edit' : 'offer/'+item.id" tag="a" style="display: flex; justify-content: center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18px" viewBox="0 0 24 24">
                  <path fill="#2CB181" d="M 12 4 C 4 4 1 12 1 12 C 1 12 4 20 12 20 C 20 20 23 12 23 12 C 23 12 20 4 12 4 z M 12 6 C 17.276 6 19.944594 10.267094 20.808594 11.996094 C 19.943594 13.713094 17.255 18 12 18 C 6.724 18 4.0554062 13.732906 3.1914062 12.003906 C 4.0574062 10.286906 6.745 6 12 6 z M 12 8 C 9.791 8 8 9.791 8 12 C 8 14.209 9.791 16 12 16 C 14.209 16 16 14.209 16 12 C 16 9.791 14.209 8 12 8 z M 12 10 C 13.105 10 14 10.895 14 12 C 14 13.105 13.105 14 12 14 C 10.895 14 10 13.105 10 12 C 10 10.895 10.895 10 12 10 z"></path>
                </svg>
              </router-link>
            </td>
            <td style="position: relative;">
<!--              <div class="menu">-->
<!--                <img src="../assets/icons/eclipse-menu.svg" alt="">-->
<!--              </div>-->
              <div class="menu" v-if="!purchaser && item.status > 0 || purchaser" style="display: flex" @click="openMenu(item.id)">
                <img  height="18px" src="@/assets/icons/dots.svg" alt="">
              </div>
              <offer-menu
                  :ref="`menu${item.id}`"
                  :item="item"
                  @refresh="getOffers"
              />
            </td>
          </tr>
        </table>
      </loading-container>
      </div>
      <pagination
          :key="paginat"
          v-show="last_page > 1"
          v-model="page"
          :page-count="last_page"
      />
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import OfferMenu from "@/pages/offer/offer-menu";
import Pagination from "@/components/pagination";

export default {
  name: "offers",
  components: {
    LoadingContainer,
    OfferMenu,
    Pagination
  },
  data: ()=>({
    last_page: 0,
    per_page: 10,
    paginat: null,
    page: 0,
    loading: false,
    purchaser: false,
    search: '',
    select_key: 0,
    selected: '',
    navs: [
      {
        title: 'Все',
        name: 'Offers',
        status: 0
      },
      {
        title: 'Заключается договор',
        name: 'force',
        status: 4
      },
      {
        title: 'Потенциально интересно',
        name: 'force',
        status: 3
      },
      {
        title: 'Отклоненные',
        name: 'force',
        status: 2
      },

    ],
    offers: null
  }),
  mounted() {
    this.purchaser = localStorage.getItem('type') == 1 ? false : true;
    this.getOffers(0);
  },
  methods: {
    changePerPage(val) {
      this.per_page = val;
      if (this.page === 1) {
        this.loading = true;
        this.getOffers();
      } else {
        this.page = 1;
      }
    },
    searchOffers(){
        this.getOffers();
    },
    changeFilter(val,status) {
      this.select_key = val;

      this.loading = true;
      this.getOffers(status);
    },
    openMenu(val) {
      for (const key in this.offers) {
        this.$refs['menu'+ this.offers[key].id][0].close();
      }
      if (this.selected != val) {
        this.selected = val;
        this.$refs['menu'+ val][0].open();
      } else {
        this.selected = '';
      }
    },
    getOffers(status){
      this.$http.post('/get-offers', {
        token: localStorage.getItem('token'),
        filter:status,
        search:this.search,
        page:this.page,
        per_page: this.per_page,
      }).then(({data}) => {
        if (data.offers){
          this.offers = data.offers.data;
          this.last_page = data.offers.last_page;
          this.page = data.offers.current_page;
          this.loading = false;
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  watch: {
    page: function (val) {
      if (val >= 1) {
        this.loading = true;
        this.getOffers();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  height: 40px;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  .tabs{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    justify-content: center;
    width: max-content;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #EEF0F3;
    margin-right: auto;

    &-item {
      margin: 0;
      position: relative;
      cursor: pointer;
      padding: 10px 15px;
      margin: 2px 0 2px 0;
      color: #7A818F;
    }
    &-item:first-child{
      margin-left: 2px;
    }
    &-item:last-child{
      margin-right: 2px;
    }
    &-item.active {
      background: #EEF0F3;
      border-radius: 4px;
    }

    &-item:after{
      border-left: 1px solid #EEF0F3;
      content: " ";
      position: absolute;
      top: 35%;
      right: 0;
      height: 30%;
      margin-top: auto;
      margin-bottom: auto;
    }
    &-item:last-child:after{
      border-left: unset;
    }
  }

  button{
    margin-left: 15px;
    border: none;
    height: 40px;
    width: 10%;
    background: #2CB181;
    border-radius: 4px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
  }
  .search {
    position: relative;
    width: 20%;
    display: flex;
    justify-content: flex-end;

    > input {
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      padding: 0 40px 0 15px;
      outline: none;

      &:focus{
        border: 1px solid #2CB181;
      }
    }

    > img {
      position: absolute;
      right: 15px;
      bottom: 50%;
      transform: translateY(50%);
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
}
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        &.done{
          color: #2cb181;
        }
      }
    }
    .menu{
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    //cursor: pointer ;
  }
}


</style>
